<div class="d-flex flex-row" (click)="$event.stopPropagation()">
    @if (!isEditMode && !model && !disabled) {
        <eff-icon
            class="action-icon"
            icon="new_label_outlined"
            (click)="onEdit(); $event.stopPropagation()"
        ></eff-icon>
    }
    <input
        #inputText
        autofocus
        (click)="$event.stopPropagation()"
        (keyup)="onModelChanged()"
        [disabled]="!isEditMode"
        type="text"
        [(ngModel)]="model"
    />
    @if (!isEditMode && model && !disabled) {
        <eff-icon
            class="edit-comment-icon"
            icon="edit_outlined"
            (click)="onEdit(); $event.stopPropagation()"
        ></eff-icon>
    }
</div>
